(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var anim = root.classList.contains('anim') && !reduce;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var revealEls = document.querySelectorAll('.reveal, .reveal-x');
    if (anim && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el, i) { el.style.transitionDelay = ((i % 4) * 0.07) + 's'; io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    }

    var px = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (anim && px.length) {
      var ticking = false;
      var update = function () {
        var vh = window.innerHeight;
        px.forEach(function (el) {
          var r = el.parentElement.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          var s = parseFloat(el.getAttribute('data-parallax')) || 0.1;
          el.style.transform = 'translate3d(0,' + (p * s * -160).toFixed(1) + 'px,0)';
        });
        ticking = false;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }

    if (anim && window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('[data-tilt]').forEach(function (c) {
        c.addEventListener('mousemove', function (e) {
          var r = c.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          c.style.transform = 'perspective(900px) rotateY(' + (x * 9) + 'deg) rotateX(' + (-y * 9) + 'deg) translateY(-6px)';
        });
        c.addEventListener('mouseleave', function () { c.style.transform = ''; });
      });
    }

    var toggle = document.querySelector('[data-nav-toggle]');
    if (toggle) toggle.addEventListener('click', function () { document.body.classList.toggle('nav-open'); });

    document.querySelectorAll('[data-filter-root]').forEach(function (fr) {
      fr.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-filter]');
        if (!chip) return;
        var f = chip.getAttribute('data-filter');
        fr.querySelectorAll('[data-filter]').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        fr.querySelectorAll('.card[data-type]').forEach(function (card) {
          card.classList.toggle('is-hidden', f !== 'all' && card.getAttribute('data-type') !== f);
        });
      });
    });

    document.querySelectorAll('[data-product]').forEach(initProduct);

    var recs = document.querySelector('[data-recs]');
    if (recs && window.fetch) {
      fetch(recs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) {
          recs.innerHTML = fresh.innerHTML;
          recs.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
        }
      });
    }
  });

  function money(cents) {
    try { return new Intl.NumberFormat(root.lang || 'en-IE', { style: 'currency', currency: window.shopCurrency || 'EUR' }).format(cents / 100); }
    catch (e) { return '€' + (cents / 100).toFixed(2); }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800); }
      })
      .catch(function (err) {
        if (btn) { btn.innerHTML = (err && err.description) || 'Try again'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 2600); }
      });
  });

  function initProduct(el) {
    var jsonEl = el.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = el.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('[name="id"]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var qtyInput = form.querySelector('[data-qty]');
    var addBtn = form.querySelector('[data-add]');
    var mainImg = el.querySelector('[data-main-img]');

    function currentVariant() {
      var groups = el.querySelectorAll('[data-option]');
      if (!groups.length) return product.variants[0];
      var chosen = Array.prototype.map.call(groups, function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return chosen[i] == null || o === chosen[i]; }); });
    }
    function currentPlan() { var c = form.querySelector('[name="purchase_option"]:checked'); return c ? c.value : ''; }
    function priceFor(v) {
      var plan = currentPlan();
      if (plan && v.selling_plan_allocations) {
        var a = v.selling_plan_allocations.find(function (x) { return String(x.selling_plan_id) === String(plan); });
        if (a) return a.price;
      }
      return v.price;
    }
    function update(swapImage) {
      var v = currentVariant();
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      var plan = currentPlan();
      if (planInput) { planInput.value = plan; planInput.disabled = !plan; }
      el.querySelectorAll('[data-price]').forEach(function (p) { p.textContent = money(v.price); });
      el.querySelectorAll('[data-plan-price]').forEach(function (p) {
        var a = (v.selling_plan_allocations || []).find(function (x) { return String(x.selling_plan_id) === p.getAttribute('data-plan-price'); });
        p.textContent = a ? money(a.price) : '';
      });
      var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      addBtn.disabled = !v.available;
      addBtn.innerHTML = v.available ? (plan ? 'Subscribe & add to cart' : 'Add to cart') : 'Sold out';
      var big = el.querySelector('[data-total-big]'); if (big) big.textContent = money(priceFor(v) * q);
      var sum = el.querySelector('[data-summary]');
      if (sum) { var pl = form.querySelector('[name="purchase_option"]:checked'); var pn = pl && pl.value ? pl.closest('label').querySelector('.purchase__name').firstChild.textContent.trim() : 'One-off'; sum.textContent = v.title.replace('Default Title', '') + (v.title === 'Default Title' ? '' : ' · ') + pn + (q > 1 ? ' · × ' + q : ''); }
      var note = el.querySelector('[data-price-note]'); if (note) note.textContent = plan ? 'Subscription price' : (q > 1 ? q + ' × ' + money(v.price) : 'Incl. VAT');
      if (swapImage && v.featured_image && mainImg) mainImg.src = v.featured_image.src;
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    el.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    form.querySelectorAll('[name="purchase_option"]').forEach(function (i) { i.addEventListener('change', function () { update(false); }); });
    qtyInput.addEventListener('input', function () { update(false); });
    form.querySelector('[data-qty-minus]').addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); update(false); });
    form.querySelector('[data-qty-plus]').addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; update(false); });

    el.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        el.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
        if (mainImg) { mainImg.style.opacity = 0; setTimeout(function () { mainImg.src = t.getAttribute('data-thumb'); mainImg.style.opacity = 1; }, 180); }
      });
    });
    update(false);
  }
})();

(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function chipFilter(root, chipAttr, itemSel, itemAttr) {
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[' + chipAttr + ']');
      if (!chip) return;
      var v = chip.getAttribute(chipAttr);
      root.querySelectorAll('[' + chipAttr + ']').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      root.querySelectorAll(itemSel).forEach(function (it) { it.classList.toggle('is-hidden', v !== 'all' && it.getAttribute(itemAttr) !== v); });
    });
  }
  ready(function () {
    document.querySelectorAll('[data-stock]').forEach(function (r) { chipFilter(r, 'data-county', '.stockist', 'data-c'); });
    document.querySelectorAll('[data-faq]').forEach(function (r) { chipFilter(r, 'data-topic', 'details', 'data-t'); });
    document.querySelectorAll('[data-ph]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var ta = radio.form && radio.form.querySelector('textarea[name="contact[body]"]');
        if (ta) ta.placeholder = radio.getAttribute('data-ph');
      });
    });
    document.querySelectorAll('[data-gift]').forEach(function (g) {
      var bottle = g.querySelector('[data-gift-bottle]'), flav = g.querySelector('[data-gift-flavour]'), msg = g.querySelector('[data-gift-msg]');
      var input = g.querySelector('[data-gift-input]'), left = g.querySelector('[data-gift-left]');
      var idInput = g.querySelector('[data-gift-id]'), priceEl = g.querySelector('[data-gift-price]');
      function paint() {
        var f = g.querySelector('input[name="properties[Flavour]"]:checked');
        if (f) { bottle.style.background = f.getAttribute('data-colour'); flav.textContent = f.value; }
        if (input) { msg.textContent = input.value || ' '; left.textContent = input.maxLength - input.value.length; }
        var v = g.querySelector('input[name="gift_variant"]:checked');
        if (v && idInput) { idInput.value = v.value; priceEl.textContent = v.getAttribute('data-price'); }
      }
      g.addEventListener('input', paint); g.addEventListener('change', paint); paint();
    });
    document.querySelectorAll('[data-bundle]').forEach(function (b) {
      var picked = [];
      var tray = b.querySelector('[data-tray]'), empty = b.querySelector('[data-empty]');
      var countEl = b.querySelector('[data-count]'), sizeEl = b.querySelector('[data-size]');
      var cta = b.querySelector('[data-bundle-cta]'), props = b.querySelector('[data-props]');
      var boxId = b.querySelector('[data-box-id]'), boxPrice = b.querySelector('[data-box-price]');
      function box() { return b.querySelector('input[name="bundle_box"]:checked'); }
      function size() { var x = box(); return x ? parseInt(x.getAttribute('data-size'), 10) : 6; }
      function render() {
        var n = size();
        if (picked.length > n) picked = picked.slice(0, n);
        var x = box();
        boxId.value = x ? x.value : '';
        boxPrice.textContent = x ? x.getAttribute('data-price') : '';
        sizeEl.textContent = n; countEl.textContent = picked.length;
        tray.innerHTML = ''; props.innerHTML = '';
        picked.forEach(function (name, i) {
          var li = document.createElement('li');
          var sp = document.createElement('span'); sp.textContent = name; li.appendChild(sp);
          var rm = document.createElement('button'); rm.type = 'button'; rm.textContent = '×'; rm.setAttribute('aria-label', 'Remove');
          rm.addEventListener('click', function () { picked.splice(i, 1); render(); });
          li.appendChild(rm); tray.appendChild(li);
          var hp = document.createElement('input'); hp.type = 'hidden'; hp.name = 'properties[Bottle ' + (i + 1) + ']'; hp.value = name; props.appendChild(hp);
        });
        empty.style.display = picked.length ? 'none' : '';
        b.querySelectorAll('[data-pick]').forEach(function (p) {
          var c = picked.filter(function (y) { return y === p.getAttribute('data-pick'); }).length;
          p.classList.toggle('has-count', c > 0);
          p.querySelector('[data-badge]').textContent = c ? '× ' + c : '';
        });
        var full = picked.length === n && !!boxId.value;
        cta.disabled = !full;
        cta.textContent = !boxId.value ? 'Set a box product in the editor' : (full ? 'Add box to cart' : 'Pick ' + (n - picked.length) + ' more');
      }
      b.addEventListener('click', function (e) {
        var p = e.target.closest('[data-pick]');
        if (p && picked.length < size()) { picked.push(p.getAttribute('data-pick')); render(); }
      });
      b.addEventListener('change', function (e) { if (e.target.name === 'bundle_box') render(); });
      render();
    });
  });
})();
